import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./utils/i18n";
import { UserProvider } from "./Context/UserContext/UserContext";
import { initAnalytics } from "./utils/analytics";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
initAnalytics();

root.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
